import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ManualProSection() {
  const comparison = [{
    sit: 'Cliente que no paga',
    sin: 'No sabés cómo reclamar',
    con: 'Protocolo de 4 avisos listo'
  }, {
    sit: 'Te piden trabajo extra',
    sin: 'Lo hacés gratis',
    con: 'Cobro adicional acordado'
  }, {
    sit: 'Querés cobrar más',
    sin: 'Miedo a perder el cliente',
    con: 'Script de aumento listo'
  }, {
    sit: 'Necesitás un contrato',
    sin: 'Trabajás de palabra',
    con: 'Modelo completo para Argentina'
  }, {
    sit: 'Querés crecer',
    sin: 'No sabés cómo',
    con: 'Plan de escalado a 12 meses'
  }];
  const includes = ['Contrato completo para Argentina', 'Guía de Monotributo y Facturación AFIP', 'Sistema de cobro recurrente — Mercado Pago', 'Protocolo anti-morosos — 4 avisos listos', 'Método de 3 paquetes de servicios', 'ChatGPT y automatizaciones aplicadas', 'Plan de escalado a 12 meses'];
  return <section className="bg-night py-12 border-y border-white/10" data-id="element-176">
      <div className="max-w-5xl mx-auto px-6" data-id="element-177">
        <div className="text-center mb-8" data-id="element-178">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-179">
            🕊️ ¿QUÉ AGREGA EL MANUAL PRO?
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-180">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="glass overflow-hidden rounded-2xl" data-id="element-181">
            <table className="w-full text-left border-collapse" data-id="element-182">
              <thead data-id="element-183">
                <tr data-id="element-184">
                  <th className="bg-white/5 p-4 font-bold text-white border-b border-white/10" data-id="element-185">
                    Situación
                  </th>
                  <th className="bg-red-500/10 p-4 font-bold text-red-400 border-b border-white/10 text-center" data-id="element-186">
                    ❌ Sin Pro
                  </th>
                  <th className="bg-gold-accent/10 p-4 font-bold text-gold-accent border-b border-white/10 text-center" data-id="element-187">
                    ✅ Con Pro
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/10" data-id="element-188">
                {comparison.map((row, idx) => <tr key={idx} data-id="element-189">
                    <td className="p-4 text-white font-medium" data-id="element-190">{row.sit}</td>
                    <td className="p-4 text-textLight text-center text-sm" data-id="element-191">
                      {row.sin}
                    </td>
                    <td className="p-4 text-gold-accent font-bold text-center text-sm bg-gold-accent/5" data-id="element-192">
                      {row.con}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="glass rounded-2xl p-8" data-id="element-193">
            <h3 className="text-2xl font-bold text-gold-accent mb-6" data-id="element-194">
              El Manual Pro incluye:
            </h3>
            <ul className="space-y-4" data-id="element-195">
              {includes.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-196">
                  <CheckCircle2 className="w-6 h-6 text-gold-accent flex-shrink-0 mt-0.5" data-id="element-197" />
                  <span className="text-white font-medium text-lg" data-id="element-198">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}